import Axios from 'axios';
import { useEffect, useState } from 'react';

import * as Routes from '@/modules/routes';

import { PickerOption } from './usePrograms';

interface LessonData {
  id: number;
  title: string;
  title_with_position: string;
}

// Loads the lessons for the selected program (ordered by unit then position) via the
// nested program-lessons API. Returns an empty list when no program is chosen.
const useLessons = (programId: number | null) => {
  const [lessons, setLessons] = useState<PickerOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!programId) {
      setLessons([]);
      return;
    }

    setIsLoading(true);
    const path = Routes.plato_api_program_lessons_path(programId, { only: ['id', 'title', 'title_with_position'] });

    Axios.get<{ data: LessonData[] }>(path)
      .then(({ data }) => {
        setLessons(data.data.map(l => ({ label: l.title_with_position || l.title, value: l.id })));
      })
      // A failed fetch must not leave the PREVIOUS program's lessons listed (or reject unhandled).
      .catch(() => setLessons([]))
      .finally(() => setIsLoading(false));
  }, [programId]);

  return { isLoading, lessons };
};

export default useLessons;
